export default "__VITE_ASSET__DP4keizP__"